import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, ChevronDownIcon, GlobeIcon, MailIcon, ShieldCheckIcon, SmartphoneIcon } from 'lucide-react';
import { costs, faqs, purchases } from '../data/closing';
export function GuaranteeAndFaq() {
  const [open, setOpen] = useState<number | null>(null);
  return <>
      <section className="bg-surface px-4 py-16 sm:py-24" data-id="element-21" data-mp="3pmbrfc9mo6zq">
        <div className="mx-auto max-w-3xl text-center" data-id="element-22" data-mp="3bsc8ilyzfzxk">
          <ShieldCheckIcon className="mx-auto h-16 w-16 text-primary-soft" aria-hidden="true" data-id="element-23" data-mp="3gjkibj485nb9" />
          <h2 className="mt-5 font-display text-3xl font-bold sm:text-4xl" data-id="element-24" data-mp="31v6h1cmgi6wt">
            GARANTÍA 30 DÍAS — SIN COMPLICACIONES
          </h2>
          <div className="mt-8 rounded-2xl border-2 border-primary/40 p-7 sm:p-10" data-id="element-25" data-mp="36usthjugnj4k">
            <p className="font-semibold text-foreground" data-id="element-26" data-mp="2svay2lmnt7m8">
              Probá PACK COMIDAS RESUELTAS™.
            </p>
            <p className="mt-4 text-foreground-muted" data-id="element-27" data-mp="2wvbpd6uuxdap">
              Explorá el sistema, organizá tus comidas y aplicá las herramientas.
            </p>
            <p className="mt-4 text-foreground-muted" data-id="element-28" data-mp="2asyyha3xs1vv">
              Si dentro de 30 días sentís que no es para vos, podés solicitar el reintegro según las condiciones de la garantía.
            </p>
            <p className="mt-5 font-display text-3xl font-bold text-primary-soft sm:text-4xl" data-id="element-29" data-mp="2kr64wz0ln1jm">
              30 días para probarlo.
            </p>
            <p className="mt-2 text-lg font-bold" data-id="element-30" data-mp="1x1tu5upmilf7">Sin quedarte atado/a a la compra.</p>
          </div>
        </div>
      </section>

      <section className="bg-canvas px-4 py-16 sm:py-24" data-id="element-31" data-mp="1s0edsfye5335">
        <div className="mx-auto max-w-3xl" data-id="element-32" data-mp="26rww4keq39po">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-33" data-mp="220ezg8jqfvai">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="mt-10 space-y-3" data-id="element-34" data-mp="1ea12c3maj692">
            {faqs.map(({
            question,
            answer
          }, index) => {
            const panelId = `faq-panel-${index}`;
            return <div key={question} className="overflow-hidden rounded-xl border border-foreground/10 bg-surface" data-id="element-35" data-mp="1z0ojg4o1fpt3" data-mpi={index}>
                  <button type="button" onClick={() => setOpen(open === index ? null : index)} aria-expanded={open === index} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 p-5 text-left font-bold transition-colors duration-150 ease-out hover:text-primary-soft sm:text-lg" data-id="element-36" data-mp="230f73zi9ppte">
                    <span data-id="element-37" data-mp="1g2c606q3ftrp">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-primary-soft transition-transform duration-200 ease-out ${open === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-38" data-mp="1k2mepr59sya9" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-39" data-mp="1u0ipuiy7jt8d">
                    {open === index && <motion.div id={panelId} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} data-id="element-40" data-mp="1tyfmyybyi5m8">
                        <p className="border-t border-foreground/10 px-5 py-5 leading-relaxed text-foreground-muted" data-id="element-41" data-mp="k2ix4fiz510k">
                          {answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}
export function CostSection() {
  return <section className="bg-surface px-4 py-16 sm:py-24" data-id="element-42" data-mp="6543szplo93b">
      <div className="mx-auto max-w-4xl" data-id="element-43" data-mp="14zjeylkmu7t">
        <h2 className="text-center font-display text-3xl font-bold text-highlight sm:text-4xl" data-id="element-44" data-mp="15rgyeyqb20q">
          ⚖️ ¿CUÁNTO TE CUESTA SEGUIR IMPROVISANDO?
        </h2>
        <div className="mt-10 overflow-hidden rounded-2xl border border-line-strong" data-id="element-45" data-mp="1vgo3ff6ntmz2">
          {costs.map(item => <p key={item} className="border-b border-l-4 border-line-strong border-l-line-accent bg-surface-raised px-5 py-4 font-medium last:border-b-0" data-id="element-46" data-mp="1qk5xwd3i9klo">
              <span className="mr-2 text-danger-soft" aria-hidden="true" data-id="element-47" data-mp="23idifonrzjdy">
                ×
              </span>
              {item}
            </p>)}
        </div>
        <div className="mt-10 text-center" data-id="element-48" data-mp="1ol4kud7vpjds">
          <p className="text-lg text-foreground-muted" data-id="element-49" data-mp="1tjy1geigpqi6">Otra semana puede empezar diferente.</p>
          <p className="mt-3 font-display text-2xl font-bold text-primary-soft sm:text-3xl" data-id="element-50" data-mp="1fsj7xdqxi6wv">
            No necesitás más recetas. Necesitás un sistema.
          </p>
        </div>
      </div>
    </section>;
}
export function FooterAndProofPopup() {
  const [purchase, setPurchase] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimer: number | undefined;
    const timer = window.setInterval(() => {
      setPurchase(value => (value + 1) % purchases.length);
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), 5000);
    }, 40000);
    return () => {
      window.clearInterval(timer);
      window.clearTimeout(hideTimer);
    };
  }, []);
  return <>
      <footer className="border-t border-foreground/10 bg-canvas px-4 py-12 text-center" data-id="element-51" data-mp="d9q5eqlk8no2">
        <span className="inline-block rounded-full border border-primary/25 bg-primary/10 px-3 py-1 text-sm font-semibold text-primary-soft" data-id="element-52" data-mp="r8zd11vpa9gf">
          PACK COMIDAS RESUELTAS™
        </span>
        <p className="mx-auto mt-4 max-w-md font-semibold text-foreground-muted" data-id="element-53" data-mp="115c55vblkf92">
          El sistema práctico para planificar, preparar, congelar y tener comidas listas para usar durante la semana.
        </p>
        <p className="mx-auto mt-2 max-w-md text-sm italic text-foreground-faint" data-id="element-54" data-mp="19xe4trdudria">
          “Porque cuando tus comidas están resueltas, también se siente más liviana tu semana.”
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-foreground-subtle" data-id="element-55" data-mp="1jxwrsv0pdo4f">
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary-soft" href="mailto:soportebiomalivido@gmail.com" data-id="element-56" data-mp="1ez3izfwd2lal">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-57" data-mp="glg27assnl9j" />
            soportebiomalivido@gmail.com
          </a>
          <span className="inline-flex items-center gap-1.5" data-id="element-58" data-mp="ljznd8zkct0u">
            <SmartphoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-59" data-mp="qbr8h3zya6jl" />
            @biomalivido
          </span>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary-soft" href="https://biomalivido.com" target="_blank" rel="noreferrer" data-id="element-60" data-mp="vb40021ro1si">
            <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-61" data-mp="14binn827dsz6" />
            biomalivido.com
          </a>
        </div>
        <p className="mt-8 text-xs text-foreground-faintest" data-id="element-62" data-mp="19b52tn1ldjam">
          © PACK COMIDAS RESUELTAS™ 2026 — Todos los derechos reservados.
        </p>
      </footer>

      <AnimatePresence data-id="element-63" data-mp="3659mu3r1191q">
        {visible && <motion.aside initial={{
        x: -30,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -30,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-5 left-5 z-50 max-w-72 rounded-xl border border-primary/30 bg-canvas p-4 shadow-2xl" aria-live="polite" data-id="element-64" data-mp="3b1glrcl09ka6">
            <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-primary-soft" data-id="element-65" data-mp="2ou2z4uw7u29q">
              <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-66" data-mp="3mga445wflwmm" />
              Compra verificada
            </p>
            <p className="mt-2 text-sm font-semibold" data-id="element-67" data-mp="3hirtmb2rn9ci">
              {purchases[purchase][0]} de {purchases[purchase][1]}
            </p>
            <p className="text-sm text-foreground-muted" data-id="element-68" data-mp="38hk7sshfs0zb">
              compró Pack Comidas Resueltas™
            </p>
            <p className="mt-1 text-xs text-foreground-faint" data-id="element-69" data-mp="214i3pcivlcjk">hace unos minutos</p>
          </motion.aside>}
      </AnimatePresence>
    </>;
}